import React from 'react';

import { Spinner, SpinnerSize } from '../../../PlayerSkin/parts/Spinner';
import { MovieTrailerPlayer } from '../../../movie-trailer-player/ui/MovieTrailerPlayer';
import { FilmPlayerContainer } from '../../../film-player/ui/FilmPlayerContainer';
import { EpisodePlayer } from '../../../episode-player/ui/episode-player/EpisodePlayer';
import { ChannelPlayer } from '../../../channel-player/ui/channel-player/ChannelPlayer';
import { ContentType } from '../../types';
import { useIsReadyToPlay } from '../../hooks/use-is-ready-to-play';
import { useDefaultOnError } from '../../hooks/use-default-on-error';
import { SportLivePlayer } from '../../../SportLiverPlayer/components/SportLivePlayer/SportLivePlayer';

import styles from './styles.module.css';

interface Props {
    contentId: string;
    onClose: () => void;
    isLoading: boolean;
    contentType: ContentType | undefined;
}

export const PlayerManager = ({ contentId, isLoading, contentType, onClose }: Props) => {
    const onError = useDefaultOnError();
    const isReadyToPlay = useIsReadyToPlay();
    if (isLoading || !contentType || !isReadyToPlay) {
        return (
            <div className={styles.loader}>
                <Spinner size={SpinnerSize.BIG} />
            </div>
        );
    }

    return (
        <>
            {(contentType === 'Film' || contentType === 'Video') && (
                <FilmPlayerContainer contentId={contentId} onClose={onClose} />
            )}
            {contentType === 'Episode' && <EpisodePlayer contentId={contentId} onClose={onClose} />}
            {contentType === 'TvChannel' && (
                <ChannelPlayer channelId={contentId} onClose={onClose} />
            )}
            {contentType === 'OttTrailer' && (
                <MovieTrailerPlayer
                    contentId={contentId}
                    onTrailerEnd={onClose}
                    onClose={onClose}
                    onError={onError}
                />
            )}
            {contentType === 'SportBroadcast' && (
                <SportLivePlayer sportLiveContentId={contentId} onClose={onClose} />
            )}
        </>
    );
};
